import { ChevronRight } from 'react-feather'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCity } from '@fortawesome/free-solid-svg-icons'
import { FormattedMessage } from 'react-intl'


export default [
    {
        id: 'aboutUs',
        title: <FormattedMessage id='About Us' />,
        icon: <FontAwesomeIcon icon={faCity} />,
        navLink: '/aboutUs',

        children: [
            {
                id: 'Feed Mill',
                title: <FormattedMessage id='Feed Mill' />,
                icon: <ChevronRight />,
                navLink: '/feedMill'
            },

            {
                id: 'Quality Policy',
                title: <FormattedMessage id='Quality Policy' />,
                icon: <ChevronRight />,
                navLink: '/qualitypolicy'
            },

            {
                id: 'Privacy Policy1',
                title: <FormattedMessage id='Privacy Policy' />,
                icon: <ChevronRight />,
                navLink: '/privacypolicy'
            },


            {
                id: 'Cookie Policy',
                title: <FormattedMessage id='Cookie Policy' />,
                icon: <ChevronRight />,
                navLink: '/cookie1'
            },

            // {
            //     id: 'Privacy Policy',
            //     title: <FormattedMessage id='Privacy Policy' />,
            //     icon: <ChevronRight />,
            //     navLink: '/privacy'
            // },

            {
                id: 'Privacy Policy',
                title: <FormattedMessage id='Privacy Notice' />,
                icon: <ChevronRight />,
                navLink: '/privacy1'
            },


            {
                id: 'Corporate Governance',
                title: <FormattedMessage id='Corporate Governance' />,
                icon: <ChevronRight />,
                navLink: '/corporategovernance'
            },

            // {
            //     id: 'Terms and Conditions',
            //     title: <FormattedMessage id='Terms and Conditions' />,
            //     icon: <ChevronRight />,
            //     navLink: '/terms'
            // },

            {
                id: 'Complain',
                title: <FormattedMessage id='Complain' />,
                icon: <ChevronRight />,
                navLink: '/complain'
            },

            {
                id: 'Contact and Map',
                title: <FormattedMessage id='Contact and Map' />,
                icon: <ChevronRight />,
                navLink: '/contact'

            }

        ]

    }

]